<template>
    <b-modal
        id="edit-category-modal"
        v-model="modal"
        ref="edit-category-modal"
        size="lg"
        :title="$t('learning_path.edit_work_field')"
        modal-class="apprentice-default-modal edit-category"
        ok-title="Update"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk">
        <div class="lp-category-edit">
            <div
                class="lb-category-banner-preview"
                v-if="banner_preview !== ''">
                <b-img :src="banner_preview"></b-img>
            </div>
            <div
                class="errors"
                v-if="errorsFound">
                <b-alert
                    v-for="(error, index) in errors"
                    v-if="error.error"
                    show
                    variant="danger"
                    :key="`error-${index}`"
                    >{{ error.message }}
                </b-alert>
            </div>
            <b-form-group
                class="category-name"
                label-for="category-name-input"
                :label="$t('common.name')">
                <template v-slot:label> {{ $t('common.name') }} <span class="required">*</span> </template>
                <b-form-input
                    id="category-name-input"
                    v-model="name"
                    :placeholder="$t('learning_path.work_field_name')">
                </b-form-input>
            </b-form-group>
            <b-form-group
                class="category-description"
                label-for="category-description-input"
                :label="$t('common.description')">
                <template v-slot:label> {{ $t('common.description') }} <span class="required">*</span> </template>
                <ckeditor
                    v-model="description"
                    :editor="editor"
                    :config="editorConfig">
                </ckeditor>
            </b-form-group>
            <b-form-group
                class="group-input-file"
                :label="$t('learning_path.image')"
                label-for="lb-category-banner-input">
                <b-form-file
                    class="apprentice-file-upload"
                    id="lb-category-banner-input"
                    v-model="file"
                    accept="image/jpeg,image/png"
                    :placeholder="$t('learning_path.upload_banner')"
                    @change="showPreview"></b-form-file>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-edit-learning-path-category-modal',
    data() {
        return {
            category: null,
            name: null,
            description: '',
            file: null,
            banner_preview: '',
            modal: false,
            errorsFound: false,
            errors: {
                name: {
                    error: false,
                    message: this.$t('learning_path.name_cannot_be_empty'),
                },
                description: {
                    error: false,
                    message: this.$t('learning_path.description_cannot_be_empty'),
                },
            },
            editor: ApprenticeEditor,
            editorConfig: {
                placeholder: this.$t('learning_path.work_field_description'),
                bodyClass: 'lp-category-body',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'imageInsert',
                        'mediaEmbed',
                        'insertTable',
                        '|',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                simpleUpload: {
                    uploadUrl: this.routes.baseUrl() + '/image/upload',
                },
            },
        };
    },
    methods: {
        showPreview(evt) {
            const file = evt.target.files[0];
            this.banner_preview = URL.createObjectURL(file);
        },
        onOk(bvModalEvent) {
            if (this.hasErrors()) {
                bvModalEvent.preventDefault();
                return;
            }
            const formData = new FormData();
            formData.append('name', this.name);
            formData.append('description', this.description);
            if (this.file) {
                formData.append('file', this.file);
            }
            const headers = { 'Content-Type': 'multipart/form-data' };

            this.alert.saving();
            axios.post(this.routes.updateLpCategory(this.category.id), formData, { headers: headers }).then(
                (response) => {
                    this.$emit('updateCategory', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        show(category) {
            this.errorsFound = false;
            this.errors.name.error = false;
            this.errors.description.error = false;
            this.category = category;
            this.name = category.name;
            this.description = category.description !== null ? category.description : '';
            this.banner_preview = category.file.path;
            this.modal = true;
        },

        hasErrors() {
            this.errorsFound = false;
            this.errors.name.error = false;
            this.errors.description.error = false;
            let errors = false;

            if (this.name === null || this.name === '') {
                this.errorsFound = true;
                this.errors.name.error = true;
                errors = true;
            }

            if (this.description === null || this.description === '') {
                this.errorsFound = true;
                this.errors.description.error = true;
                errors = true;
            }

            return errors;
        },
    },
};
</script>

<style scoped lang="scss">
.lb-category-banner-preview {
    margin-bottom: $grid-gutter-width;

    img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 150px;
    }
}
</style>
